import { RootProvider } from "@view/root/RootProvider/RootProvider";
import RootRouter from "@routers/RootRouter";
import RootScene from "@view/root/RootScene/RootScene";
import { App as AntApp } from "antd";
import { HelmetProvider } from "react-helmet-async";

const App = (): JSX.Element => (
  <HelmetProvider>
    <RootProvider>
      <AntApp>
        <RootRouter />
        <RootScene />
      </AntApp>
    </RootProvider>
  </HelmetProvider>
);

export default App;
